"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeToExpiration = exports.SsoProvider = exports.ShareType = exports.Screen = exports.Reward = exports.RequestReason = exports.ReferralType = exports.ReferralSource = exports.PromotionRewardType = exports.Origin = exports.Modification = exports.ManagementType = exports.InvestmentType = exports.InitiatedBy = exports.FrequencyType = exports.FrequencySchedule = exports.FlowType = exports.FeedbackType = exports.ExpiredAfter = exports.DocumentType = exports.ChangeType = exports.BillingFrequency = exports.AccountType = void 0;
/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

const ChangeType = exports.ChangeType = {
  pause: 'pause',
  remove: 'remove',
  modify: 'modify'
};
const Screen = exports.Screen = {
  autoInvestManagement: 'auto_invest_management',
  autostashActionOptions: 'autostash_action_options',
  autostashDetails: 'autostash_details',
  autostashModule: 'autostash_module',
  autostashPauseSpeedbump: 'autostash_pause_speedbump',
  autostashProjectiongraph: 'autostash_projectiongraph',
  browseInvestments: 'browse_investments',
  buySetup: 'buy_setup',
  buySetupResult: 'buy_setup_result',
  buysetup: 'buysetup',
  cardDetails: 'card_details',
  cardLinkingSetup: 'card_linking_setup',
  changePaymentMethod: 'change_payment_method',
  coachFeed: 'coach_feed',
  combinedPaymentMethods: 'combined_payment_methods',
  diversificationAnalysis: 'diversification_analysis',
  externalAccountLinkFailed: 'external_account_link_failed',
  externalAccountLinkMain: 'external_account_link_main',
  externalAccountLinkMicros: 'external_account_link_micros',
  externalAccountLinkOnboarding: 'external_account_link_onboarding',
  goalCreateName: 'goal_create_name',
  goalCreateTargets: 'goal_create_targets',
  goalsHome: 'goals_home',
  goalsModule: 'goals_module',
  home: 'home',
  invest: 'invest',
  investBuyResults: 'invest_buy_results',
  investPortfolio: 'invest_portfolio',
  investmentDetails: 'investment_details',
  investmentSearch: 'investment_search',
  iraTypeSelection: 'ira_type_selection',
  learnAndEarnNextSteps: 'learn_and_earn_next_steps',
  loginPage: 'login_page',
  longTermGoalDetails: 'long_term_goal_details',
  marketingHome: 'marketing_home',
  microFailureExceededAttempts: 'micro_failure_exceeded_attempts',
  moneyMovementDestinationSheet: 'money_movement_destination_sheet',
  moneyMovementSetup: 'money_movement_setup',
  moneyMovementSourceSheet: 'money_movement_source_sheet',
  mystashHome: 'mystash_home',
  mystashModule: 'mystash_module',
  notificationsModule: 'notifications_module',
  paymentMethodActionOptions: 'payment_method_action_options',
  paywallModule: 'paywall_module',
  portfoliooverview: 'portfoliooverview',
  quicklinksModule: 'quicklinks_module',
  recurringTransactionAuthorization: 'recurring_transaction_authorization',
  rewardsCenter: 'rewards_center',
  selfDirectedSetup: 'self_directed_setup',
  shortTermGoalDetails: 'short_term_goal_details',
  signupPage: 'signup_page',
  smartDetails: 'smart_details',
  smartOverview: 'smart_overview',
  smartRecommendation: 'smart_recommendation',
  stashGrowthMonthlyRetentionOffer: 'stash_growth_monthly_retention_offer',
  stockPartyAfterParty: 'stock_party_after_party',
  stockPartyPostClaim: 'stock_party_post_claim',
  stockPartyPreClaim: 'stock_party_pre_claim',
  stockPartyPreParty: 'stock_party_pre_party',
  subscriptionCancelFailed: 'subscription_cancel_failed',
  subscriptionDetails: 'subscription_details',
  welcomePage: 'welcome_page'
};
const AccountType = exports.AccountType = {
  traditionalIra: 'traditional_ira',
  rothIra: 'roth_ira',
  personalBrokerage: 'personal_brokerage',
  personalPortfolio: 'personal_portfolio',
  custodial: 'custodial',
  bank: 'bank',
  retirement: 'retirement'
};
const BillingFrequency = exports.BillingFrequency = {
  monthly: 'monthly',
  yearly: 'yearly'
};
const DocumentType = exports.DocumentType = {
  bankStatement: 'bank_statement',
  custodialSocialSecurityAdministrationDocument: 'custodial_social_security_administration_document',
  custodialSocialSecurityCard: 'custodial_social_security_card',
  custodialW2: 'custodial_w2',
  greenCard: 'green_card',
  legalNameChangeDocument: 'legal_name_change_document',
  license: 'license',
  naturalizationCertificate: 'naturalization_certificate',
  passport: 'passport',
  passportWithSelfie: 'passport_with_selfie',
  photoId: 'photo_id',
  photoIdWithSelfie: 'photo_id_with_selfie',
  secondBankStatement: 'second_bank_statement',
  socialSecurityAdministrationDocument: 'social_security_administration_document',
  socialSecurityCard: 'social_security_card',
  stateId: 'state_id',
  validProofOfAddressDocument: 'valid_proof_of_address_document',
  visa: 'visa',
  w2: 'w2',
  w9: 'w9'
};
const ExpiredAfter = exports.ExpiredAfter = {
  zeroToFiveMins: 'zero_to_five_mins',
  fiveToThirtyMins: 'five_to_thirty_mins',
  thirtyMinsToOneHour: 'thirty_mins_to_one_hour',
  oneToSixHours: 'one_to_six_hours',
  sixToTwentyfourHours: 'six_to_twentyfour_hours',
  greaterThanTwentyfourHours: 'greater_than_twentyfour_hours',
  greaterThanThirtyDays: 'greater_than_thirty_days'
};
const FeedbackType = exports.FeedbackType = {
  positive: 'positive',
  negative: 'negative'
};
const FlowType = exports.FlowType = {
  addCash: 'add_cash',
  autoInvestBuyFlow: 'auto_invest_buy_flow',
  autostashDisabled: 'autostash_disabled',
  autostashEnabled: 'autostash_enabled',
  buy: 'buy',
  cancelFlow: 'cancel_flow',
  createAutostash: 'create_autostash',
  contentMoat: 'content_moat',
  createTransactionBuy: 'create_transaction_buy',
  docUpload: 'doc_upload',
  downgrade: 'downgrade',
  editGoal: 'edit_goal',
  goalsStateEngaged: 'goals_state_engaged',
  goalsStateZero: 'goals_state_zero',
  idvRestricted: 'idv_restricted',
  incomplete: 'incomplete',
  learn: 'learn',
  learnAndEarn: 'learn_and_earn',
  legacy: 'legacy',
  microPending: 'micro_pending',
  modifyAutostash: 'modify_autostash',
  modifyDob: 'modify_dob',
  modifySsn: 'modify_ssn',
  moneyMovement: 'money_movement',
  new: 'new',
  newGoal: 'new_goal',
  noLink: 'no_link',
  none: 'none',
  ob2: 'ob2',
  personal: 'personal',
  preferredPaymentMethod: 'preferred_payment_method',
  quickstartAutostash: 'quickstart_autostash',
  referredNewUser: 'referred_new_user',
  robo: 'robo',
  roboSetup: 'robo_setup',
  selfDirected: 'self_directed',
  selfDirectedSetup: 'self_directed_setup',
  smart: 'smart',
  stashworks: 'stashworks',
  transferFlow: 'transfer_flow',
  upgrade: 'upgrade',
  upgradeTier: 'upgrade_tier',
  beforeEmail: 'before_email',
  decrease: 'decrease',
  increase: 'increase'
};
const FrequencySchedule = exports.FrequencySchedule = {
  daily: 'daily',
  weekly: 'weekly',
  biweekly: 'biweekly',
  monthly: 'monthly'
};
const FrequencyType = exports.FrequencyType = {
  auto: 'auto',
  oneTime: 'one_time'
};
const InitiatedBy = exports.InitiatedBy = {
  user: 'user',
  system: 'system',
  admin: 'admin'
};
const InvestmentType = exports.InvestmentType = {
  etf: 'etf',
  stock: 'stock'
};
const ManagementType = exports.ManagementType = {
  robo: 'robo',
  selfDirected: 'self_directed'
};
const Modification = exports.Modification = {
  amount: 'amount',
  frequency: 'frequency',
  removeAllocation: 'remove_allocation',
  pause: 'pause'
};
const Origin = exports.Origin = {
  autoStash: 'auto_stash',
  bank: 'bank',
  bankActivation: 'bank_activation',
  bankOnboarding: 'bank_onboarding',
  brazeJunctureEvent: 'braze_juncture_event',
  brazeTidesEvent: 'braze_tides_event',
  cardDetails: 'card_details',
  coachFeed: 'coach_feed',
  deeplink: 'deeplink',
  discover: 'discover',
  diversificationAnalysis: 'diversification_analysis',
  goals: 'goals',
  goalsMenu: 'goals_menu',
  home: 'home',
  influencerEvent: 'influencer_event',
  invest: 'invest',
  investPortfolio: 'invest_portfolio',
  login: 'login',
  moneyMovement: 'money_movement',
  monolithWebhook: 'monolith_webhook',
  mystash: 'mystash',
  onboarding: 'onboarding',
  pencilIcon: 'pencil_icon',
  rail: 'rail',
  reactivation: 'reactivation',
  referralServiceEvent: 'referral_service_event',
  rewardsCenter: 'rewards_center',
  signup: 'signup',
  stashworks: 'stashworks',
  stateZero: 'state_zero',
  subscriptionManagement: 'subscription_management',
  toolbar: 'toolbar',
  transferFlow: 'transfer_flow',
  unfundedSimpleHome: 'unfunded_simple_home',
  userProfile: 'user_profile',
  stashCom: 'stash_com'
};
const PromotionRewardType = exports.PromotionRewardType = {
  cash: 'cash',
  subscriptionDiscount: 'subscription_discount',
  subscriptionWaive: 'subscription_waive',
  cashMatch: 'cash_match',
  stockReward: 'stock_reward'
};
const ReferralSource = exports.ReferralSource = {
  stockParty: 'stock_party',
  referralHome: 'referral_home',
  management: 'management',
  howItWorks: 'how_it_works',
  backfill: 'backfill'
};
const ReferralType = exports.ReferralType = {
  investCash: 'invest_cash',
  mysteryStock: 'mystery_stock',
  stock: 'stock',
  backfill: 'backfill'
};
const RequestReason = exports.RequestReason = {
  damaged: 'damaged',
  compromised: 'compromised',
  expired: 'expired',
  firstCard: 'first_card',
  fraud: 'fraud',
  lost: 'lost',
  neverReceived: 'never_received',
  stolen: 'stolen'
};
const Reward = exports.Reward = {
  cash: 'cash',
  stock: 'stock'
};
const ShareType = exports.ShareType = {
  clipboard: 'clipboard',
  shareOptions: 'share_options',
  email: 'email',
  facebook: 'facebook',
  sms: 'sms',
  qr: 'qr',
  xTwitter: 'x_twitter'
};
const SsoProvider = exports.SsoProvider = {
  apple: 'apple',
  google: 'google'
};
const TimeToExpiration = exports.TimeToExpiration = {
  zeroToFiveMins: 'zero_to_five_mins',
  fiveToThirtyMins: 'five_to_thirty_mins',
  thirtyMinsToOneHour: 'thirty_mins_to_one_hour',
  oneToSixHours: 'one_to_six_hours',
  sixToTwentyfourHours: 'six_to_twentyfour_hours',
  greaterThanTwentyfourHours: 'greater_than_twentyfour_hours',
  greaterThanThirtyDays: 'greater_than_thirty_days'
};
//# sourceMappingURL=enum_properties.js.map